import getHttpHeaders from './http/getHttpHeaders';

export default {
    getHttpHeaders
};
